import React from 'react';

import { Switch } from '@rbilabs/universal-components';
import { Skeleton } from 'native-base';

import PaymentMethod from 'components/payment-method';
import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants';

import { useQuickPayState } from '../hooks/use-quickpay-state';

import {
  Container,
  LeftContainer,
  PaymentContainer,
  QuickPay,
  RightContainer,
  SwitchContainer,
} from './loyalty-quick-pay-widget-redesign.styled';

export const LoyaltyQuickPayWidgetRedesign = () => {
  const enableIdAndPay = useFlag(LaunchDarklyFlag.ENABLE_ID_AND_PAY_FE);

  const {
    isAddNewCardMethodSelected,
    setShowAddPaymentMethod,
    isAddGiftCardMethodSelected,
    setIsAddGiftCardMethodSelected,
    availablePaymentMethods,
    isOrbital,
    setIsQuickPayMethodSelected,
    isQuickPayEnabled,
    selectedMethod,
    loading,
    isQuickPayAvailable,
    handleToggle,
    handleSelection,
  } = useQuickPayState();

  if (!enableIdAndPay) {
    return null;
  }

  return (
    <Container>
      <SwitchContainer>
        <LeftContainer>
          <QuickPay>{t('quickPay')}</QuickPay>
        </LeftContainer>
        <RightContainer>
          {loading ? (
            <Skeleton rounded="md" height="$8" width="$16" />
          ) : (
            <Switch
              aria-label={t('quickPay')}
              disabled={!isQuickPayAvailable}
              value={isQuickPayEnabled}
              onToggle={handleToggle}
              offTrackColor={primitive.$blackOpacity50}
              onTrackColor={primitive.$crunchyGreen}
            />
          )}
        </RightContainer>
      </SwitchContainer>
      <PaymentContainer>
        {loading ? (
          <Skeleton rounded="md" height="$14" />
        ) : (
          <PaymentMethod
            aria-expanded="true"
            methods={availablePaymentMethods}
            selectedMethodId={selectedMethod || ''}
            handleSelect={handleSelection}
            isAddCardOpen={isAddNewCardMethodSelected}
            openAddCardOnPress={setShowAddPaymentMethod}
            isAddGiftCardMethodSelected={isAddGiftCardMethodSelected}
            setIsAddGiftCardMethodSelected={setIsAddGiftCardMethodSelected}
            isOrbitalPaymentEnabled={isOrbital}
            isQuickPay
            setIsQuickPayMethodSelected={setIsQuickPayMethodSelected}
          />
        )}
      </PaymentContainer>
    </Container>
  );
};
